import { Logger } from '@nestjs/common'

export const logger = new Logger('@buka/nestjs-type-helpers')
